import React from 'react'
import { browserHistory } from 'react-router'
import TextInput from '../TextInput'
import Button from '../Button'
import classes from './Register.scss'
import 'whatwg-fetch'

class Register extends React.Component {

  constructor(props) {
    super(props)

    const self: any = this
    self.register = self.register.bind(self)
  }

  keySend(e) {
    if (e.keyCode === 13) { this.register() }
  }

  register(e) {
    const { setUsername, baseUrl } = this.props
    const password = document.getElementById('password').value
    e.preventDefault()
    if (password !== document.getElementById('password2').value) {
      return alert('Passwords do not match!')
    }
    if (!document.getElementById('register-form').checkValidity()) {
      return alert(document.getElementById('email').validationMessage)
    }
    const username = document.getElementById('username').value
    if (username.length < 1) { return alert('Please enter a username') }
    const email = document.getElementById('email').value
    if (email.length < 1) { return alert('Please enter an email') }

    if (username.length < 3 || username.length > 14) { return alert('Bad size username') }

    if (!username.match(/^\w+$/)) {
      return alert('Please use only alphanumeric characters and underscores for your username')
    }

    if (password.length < 4) { return alert('Please enter a better password') }

    fetch(`${baseUrl}/register`, {
      method: 'POST',
      body: JSON.stringify({ username, password, email, token: window.fcmToken }),
      credentials: 'include',
      mode: 'cors',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })
      .then(res => res.json())
      .then(res => {
        if (res.result === 'ok') {
          const username = res.msg
          setUsername(username)
          window.location.href = '/home'
        } else {
          alert(res.err || res.message)
        }
      })
  }

  render() {
    const { baseUrl } = this.props
    return (
      <div>
        <form id='register-form'>
          <TextInput type='email' placeholder='Email' id='email' /><br />
          <TextInput placeholder='Username' id='username' /><br />
          <TextInput type='password' placeholder='Password' id='password' /><br />
          <TextInput type='password' placeholder='Confirm Password' id='password2' onKeyUp={(e) => this.keySend(e)} /><br />
          <Button type='submit' value='Register' onClick={this.register} />
        </form>
      </div>
    )
  }
}

export default Register



/** WEBPACK FOOTER **
 ** ./src/components/Users/Register.js
 **/